import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_BASE_URL || '';

export default function DailyAssistance() {
    const { user, authorizedFetch } = useAuth();
    const [visits, setVisits] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!user) return;
        (async () => {
            try {
                const res = await authorizedFetch(`${API_URL}/api/daycare/visits/today`);
                if (!res.ok) throw new Error(await res.text());
                const todaysVisits = await res.json();
                setVisits(todaysVisits);
            } catch (err) {
                console.error(err);
                setError(err.message || 'Error al cargar las visitas');
            }
        })();
    }, [user, authorizedFetch]);

    return (
        <div className="max-w-lg mx-auto p-4">
            <h1 className="text-2xl font-semibold mb-4">Asistencia de hoy</h1>
            <div className="mb-2">Fecha: {new Date(today).toLocaleDateString('es-ES')}</div>
            {error && <p className="text-red-600 mb-2">{error}</p>}
            {visits.length === 0 ? (
                <p className="text-gray-600">Sin entradas aún.</p>
            ) : (
                <ul className="bg-white rounded shadow divide-y divide-gray-200">
                    {visits.map(v => (
                        <li key={v._id} className="p-4">
                            <div className="font-medium">{v.dog?.name || 'Perro desconocido'}</div>
                            <div className="text-gray-600">
                                Entrada: {new Date(v.checkInTime).toLocaleTimeString('es-ES')}
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
